export default [
  //-------------------------------------
  //  PARENT EVENT
  //-------------------------------------
  {
    path: '/',
    name: 'EventList',
    meta: { title: 'イベント一覧' },
    component: () => import('../views/Events.vue'),
  },
  {
    path: '/login',
    name: 'LoginParent',
    meta: { title: 'ログイン', unauthRequired: true },
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/sms/login',
    name: 'LoginSmsParent',
    meta: { title: 'ログイン', unauthRequired: true, useLoginSms: true },
    component: () => import('../views/Login.vue'),
  },
  //--PARENT PAY
  {
    path: '/pay',
    name: 'ParentPay',
    meta: { title: 'お支払い', authRequired: true, eventRequired: false },
    component: () => import('../views/Pay/Index.vue'),
  },
  {
    path: '/pay/input',
    name: 'ParentPayInput',
    meta: { title: 'お支払い', authRequired: true, eventRequired: false },
    component: () => import('../views/Pay/Input.vue'),
  },
  {
    path: '/pay/confirm',
    name: 'ParentPayConfirm',
    meta: { title: 'お支払い', authRequired: true, eventRequired: false },
    component: () => import('../views/Pay/Confirm.vue'),
  },
  {
    path: '/pay/finish',
    name: 'ParentPayFinish',
    meta: { title: 'お支払い', authRequired: true },
    component: () => import('../views/Pay/Finish.vue'),
  },
    //--SHOP
    {
      path: '/shop/:id/',
      name: 'Shop',
      meta: { title: '店舗詳細' },
      component: () => import('../views/Shop/Index.vue'),
    },
    {
      path: '/shop/:id/gallery',
      name: 'Gallery',
      meta: { title: '写真' },
      component: () => import('../views/Shop/Gallery.vue'),
    },
    {
      path: '/shop/:id/gallery/detail',
      name: 'GalleryDetail',
      meta: { title: '写真' },
      component: () => import('../views/Shop/GalleryDetail.vue'),
    },
    {
      path: '/shop/:id/menu',
      name: 'Menu',
      meta: { title: 'メニュー' },
      component: () => import('../views/Shop/Menu.vue'),
    },
    {
      path: '/shop/:id/coupon',
      name: 'Coupon',
      meta: { title: 'クーポン' },
      component: () => import('../views/Shop/Coupon.vue'),
    },
    {
      path: '/shop/:id/coupon/detail',
      name: 'CouponDetail',
      meta: { title: 'クーポン' },
      component: () => import('../views/Shop/CouponDetail.vue'),
    },
    {
      path: '/shop/:id/coupon/finish',
      name: 'CouponFinish',
      meta: { title: 'クーポン', authRequired: true },
      component: () => import('../views/Shop/CouponFinish.vue'),
    },

  //--FAVORITE
  {
    path: '/favorite',
    meta: { title: 'お気に入り', authRequired: true },
    component: () => import('../views/Favorite/Index.vue'),
    children: [
      {
        path: '',
        redirect: 'shop',
      },
      {
        path: 'shop',
        name: 'FavoriteShop',
        meta: { title: 'お店', authRequired: true },
        component: () => import('../views/Favorite/Shop.vue'),
      },
      {
        path: 'coupon',
        name: 'FavoriteCoupon',
        meta: { title: 'クーポン', authRequired: true },
        component: () => import('../views/Favorite/Coupon.vue'),
      },
      {
        path: 'photo',
        name: 'FavoritePhoto',
        meta: { title: '写真', authRequired: true },
        component: () => import('../views/Favorite/Photo.vue'),
      },
    ],
  },
  //--SECURITY
  {
    path: '/security',
    name: 'Security',
    meta: { title: 'セキュリティ', authRequired: true },
    component: () => import('../views/Security/Index.vue'),
  },
  {
    path: '/security/pincode',
    name: 'Pincode',
    meta: { title: '支払い用パスコード', authRequired: true, usePincode: true },
    component: () => import('../views/Security/Pincode.vue'),
  },
  {
    path: '/security/pincode/default',
    name: 'PincodeDefault',
    meta: { title: '支払い用パスコード', authRequired: true, usePincode: true },
    component: () => import('../views/Security/PincodeDefault.vue'),
  },
  {
    path: '/security/mail',
    name: 'Mail',
    meta: { title: 'ご登録メールアドレスの変更', authRequired: true, isMailRegisted: true, isSecurityMail: true },
    component: () => import('../views/Security/Mail.vue'),
  },
  {
    path: '/security/mail/send',
    name: 'MailSend',
    meta: { title: 'ご登録メールアドレスの変更', authRequired: true, isMailRegisted: true, isSecurityMail: true },
    component: () => import('../views/Security/MailSend.vue'),
  },
  {
    path: '/security/mail/finish/:resetEmailToken',
    name: 'MailFinish',
    meta: { title: 'ご登録メールアドレスの変更', isSecurityMail: true },
    component: () => import('../views/Security/MailFinish.vue'),
  },
  {
    path: '/security2/mail/regist',
    name: 'MailRegist',
    meta: { title: 'メールアドレスの登録', authRequired: true, isMailNotRegisted: true },
    component: () => import('../views/Security/Mail.vue'),
  },
  {
    path: '/security2/mail/regist/send',
    name: 'MailRegistSend',
    meta: { title: 'メールアドレスの登録', authRequired: true, isMailNotRegisted: true },
    component: () => import('../views/Security/MailSend.vue'),
  },
  {
    path: '/security2/mail/finish/:resetEmailToken',
    name: 'MailRegistFinish',
    meta: { title: 'メールアドレスの登録' },
    component: () => import('../views/Security/MailFinish.vue'),
  },
  {
    path: '/security/password',
    name: 'PasswordChange',
    meta: { title: 'ログインパスワード', authRequired: true, notUseLinkageApp: true },
    component: () => import('../views/Security/Password.vue'),
  },
  {
    path: '/security/password/finish',
    name: 'PasswordChangeFinish',
    meta: { title: 'ログインパスワード', authRequired: true, notUseLinkageApp: true },
    component: () => import('../views/Security/PasswordFinish.vue'),
  },
  {
    path: '/security/linkage',
    name: 'Linkage',
    meta: { title: '外部サービス連携', authRequired: true },
    component: () => import('../views/Security/Linkage.vue'),
  },
  //--ACCOOUNT
  {
    path: '/account/password',
    name: 'Password',
    meta: { title: 'ログインパスワード再設定', isEmailPassword: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/Password.vue'),
  },
  {
    path: '/account/password/send',
    name: 'PasswordSend',
    meta: { title: 'ログインパスワード再設定', isEmailPassword: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/PasswordSend.vue'),
  },
  {
    path: '/account/password/set/:resetPwToken',
    name: 'PasswordSet',
    meta: { title: 'ログインパスワード再設定', isEmailPassword: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/PasswordSet.vue'),
  },
  {
    path: '/account/password/finish',
    name: 'PasswordFinish',
    meta: { title: 'ログインパスワード再設定', isEmailPassword: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/PasswordFinish.vue'),
  },
  {
    path: '/account/password2',
    name: 'PasswordSms',
    meta: { title: 'ログインパスワード再設定', useLoginSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/Password.vue'),
  },
  {
    path: '/account/password2/send',
    name: 'PasswordSmsSend',
    meta: { title: 'ログインパスワード再設定', useLoginSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/PasswordSend.vue'),
  },
  {
    path: '/account/password2/set/:resetPwToken',
    name: 'PasswordSmsSet',
    meta: { title: 'ログインパスワード再設定', useLoginSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/PasswordSet.vue'),
  },
  {
    path: '/account/password2/finish',
    name: 'PasswordSmsFinish',
    meta: { title: 'ログインパスワード再設定', useLoginSms: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Account/PasswordFinish.vue'),
  },
  //--CONTACT
  {
    path: '/contact',
    name: 'Contact',
    meta: { title: 'お問い合わせ', isContactPage: true },
    component: () => import('../views/Contact/Index.vue'),
  },
  {
    path: '/contact/confirm',
    name: 'ContactConfirm',
    meta: { title: '入力内容確認', isContactPage: true },
    component: () => import('../views/Contact/Confirm.vue'),
  },
  {
    path: '/contact/finish',
    name: 'ContactFinish',
    meta: { title: '送信完了', isContactPage: true },
    component: () => import('../views/Contact/Finish.vue'),
  },
  //--SORRY
  {
    path: '/sorry',
    name: 'Sorry',
    meta: { title: 'Sorry' },
    component: () => import('../views/Sorry.vue'),
  },
  //--ERROR
  {
    path: '/404',
    name: '404',
    meta: { title: '404' },
    component: () => import('../views/404.vue'),
  },
  {
    path: '/500',
    name: '500',
    meta: { title: '500' },
    component: () => import('../views/500.vue'),
  },
  //--TERMS
  {
    path: '/terms/use',
    name: 'TermsUse',
    meta: { title: '利用規約' },
    component: () => import('../views/Terms/Use.vue'),
  },
  //--IDENTITY
  {
    path: '/identity/confirm',
    name: 'ParentIdentityConfirm',
    meta: { title: '本人確認', authRequired: true, useVerify: true },
    component: () => import('../views/Identity/Confirm.vue'),
  },
  {
    path: '/identity/finish',
    name: 'ParentIdentityFinish',
    meta: { title: '本人確認', authRequired: true, useVerify: true },
    component: () => import('../views/Identity/Finish.vue'),
  },
  //--IDENTITY
  {
    path: '/delete',
    name: 'ParentDelete',
    meta: { title: '退会', authRequired: true, isNotUseLinkageNecFlag: true },
    component: () => import('../views/Mypage/Delete.vue'),
  },
  {
    path: '/delete/finish',
    name: 'ParentDeleteFinish',
    meta: { title: '退会', isNotUseLinkageNecFlag: true },
    component: () => import('../views/Mypage/DeleteFinish.vue'),
  },
  //--POINT
  {
    path: '/point/keyword',
    name: 'ParentPointKeyword',
    meta: { title: 'ポイント認証', authRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Point/Keyword.vue'),
  },
  {
    path: '/point/otp',
    name: 'ParentPointOtp',
    meta: { title: 'ポイント認証', authRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Point/Otp.vue'),
  },
  {
    path: '/point/confirm',
    name: 'ParentPointConfirm',
    meta: { title: 'ポイント認証', authRequired: true, isScanQR: true },
    component: () => import('../views/Mypage/Point/Confirm.vue'),
  },
  {
    path: '/point/finish',
    name: 'ParentPointFinish',
    meta: { title: 'ポイント認証', authRequired: true },
    component: () => import('../views/Mypage/Point/Finish.vue'),
  },
  //--404
  {
    path: '/:pathMatch(.*)*',
    redirect: '404',
  },
];
